export default {"src":"/_next/static/media/logo.94f8228d.svg","height":52,"width":162,"blurWidth":0,"blurHeight":0};